import { localHref } from '@/lib/localHref';
import { today } from '@/routes/org';
import { index as contentIndex } from '@/routes/org/content';
import { index as customersIndex } from '@/routes/org/customers';
import { index as feedbackIndex } from '@/routes/org/feedback';
import { index as financeIndex } from '@/routes/org/finance';
import { index as mediaIndex } from '@/routes/org/media';
import { index as operationsIndex } from '@/routes/org/operations';
import { index as rolesIndex } from '@/routes/org/roles';
import { index as staffIndex } from '@/routes/org/staff';
import { index as supportIndex } from '@/routes/org/support';
import { index as taxonomyIndex } from '@/routes/org/taxonomy';

export interface OrgNavItem {
    key: string;
    label: string;
    href: string;
    capabilities: string[];
}

const items: OrgNavItem[] = [
    {
        key: 'today',
        label: 'Today',
        href: localHref(today()),
        capabilities: [],
    },
    {
        key: 'staff',
        label: 'Staff',
        href: localHref(staffIndex()),
        capabilities: ['staff.read'],
    },
    {
        key: 'customers',
        label: 'Customers',
        href: localHref(customersIndex()),
        capabilities: ['customers.read'],
    },
    {
        key: 'feedback',
        label: 'Feedback',
        href: localHref(feedbackIndex()),
        capabilities: ['feedback.read'],
    },
    {
        key: 'support',
        label: 'Support',
        href: localHref(supportIndex()),
        capabilities: ['support.read'],
    },
    {
        key: 'finance',
        label: 'Finance',
        href: localHref(financeIndex()),
        capabilities: ['billing.read'],
    },
    {
        key: 'operations',
        label: 'Operations',
        href: localHref(operationsIndex()),
        capabilities: ['operations.read'],
    },
    {
        key: 'posts',
        label: 'Posts',
        href: localHref(contentIndex('post')),
        capabilities: ['content.read'],
    },
    {
        key: 'pages',
        label: 'Pages',
        href: localHref(contentIndex('page')),
        capabilities: ['content.read'],
    },
    {
        key: 'media',
        label: 'Media',
        href: localHref(mediaIndex()),
        capabilities: ['content.read'],
    },
    {
        key: 'taxonomy',
        label: 'Taxonomy',
        href: localHref(taxonomyIndex()),
        capabilities: ['content.read'],
    },
    {
        key: 'roles',
        label: 'Roles',
        href: localHref(rolesIndex()),
        capabilities: ['access.roles.read'],
    },
];

/**
 * Capability-filtered Org navigation. Sidebar visibility is presentation
 * only; every destination still enforces its capability server-side.
 * Later slices append items with their required capabilities.
 */
export function orgNavigation(capabilities: string[]): OrgNavItem[] {
    return items.filter((item) =>
        item.capabilities.every((capability) =>
            capabilities.includes(capability),
        ),
    );
}
